import { ISuggestion } from '@Shared/interfaces/ISuggestion';

import { Api as apiService } from '../api';

export abstract class SuggestionsApi {
  static readonly suggestionsApiURL: string = '/api/web/suggestions';

  static get(): Promise<ISuggestion[]> {
    return apiService.responseToJSONAndToastError(apiService.get(`${SuggestionsApi.suggestionsApiURL}`));
  }

  static async getPosted() {
    return apiService.responseToJSONAndToastError(apiService.get(`${SuggestionsApi.suggestionsApiURL}?provider_state=posted`));
  }
}
